import React from 'react';

import { makeStyles, Tooltip } from '@material-ui/core';

import IconInfoDark from '../../assets/images/ic-info-dark.svg';

const useStyles = makeStyles(() => ({
  iconContainer: {
    lineHeight: '0px',
    minHeight: '0px',
  },
  iconInfoDark: {
    height: '16px',
    width: '16px',
  },
}));

const elements = (classes) => {
  return {
    info: <img src={IconInfoDark} alt="icon info" className={classes.iconInfoDark} />,
  };
};

export default ({ type = 'info', title, placement = 'right', children, wide, disabled = false }) => {
  const classes = useStyles();
  const selectedElement = elements(classes)[type];
  const tooltipClass = wide ? 'mediphany-tooltip-wide' : 'mediphany-tooltip';

  if (disabled) return children || selectedElement;

  return (
    <Tooltip classes={{ arrow: 'mediphany-arrow', tooltip: tooltipClass }} title={title} arrow placement={placement}>
      <div className={classes.iconContainer}>{children || selectedElement}</div>
    </Tooltip>
  );
};
